import { ProjectInstallationType } from 'CONFIG_TYPES';

export function checkIsCurrentInstallationType(types: ProjectInstallationType[]): boolean {
  return types.some((type) => type === PROJECT_CONFIG.installationType);
}
